import type { Profile } from '@libs/data-access/queries'
import { profileSchema } from '@libs/data-access/queries'
import { SetDesignSystemConfig } from '@libs/ui/ds'
import { useConfigurationAuthNavbar } from '@spa/components/AuthNavbar'
import type { SupportedLanguage } from '@spa/features/i18n/types'
import { useAuthState } from '@spa/scenes/Auth/shared/services'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

export const isProfileValid = (profile: unknown): profile is Profile => {
  return profileSchema.safeParse(profile).success
}

export const AccountCreation = () => {
  const { i18n } = useTranslation()
  const { auth } = useAuthState()

  useConfigurationAuthNavbar({
    cta: {
      sign_out: auth.isAccountCreationInProgress
    }
  })

  return (
    <>
      <SetDesignSystemConfig
        config={{
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: i18n.resolvedLanguage as SupportedLanguage
        }}
      />
      <Outlet />
    </>
  )
}
